import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { SnackBarService } from './snackbar.service';

@Injectable({
  providedIn: 'root',
})
export class FieldDebugService {
  private enabledSubject = new BehaviorSubject<boolean>(false);
  readonly enabled$ = this.enabledSubject.asObservable();

  constructor(private snackBarService: SnackBarService) {
  }

  isEnabled(): boolean {
    return this.enabledSubject.value;
  }

  toggle(): void {
    const nextValue = !this.enabledSubject.value;
    this.enabledSubject.next(nextValue);
    this.snackBarService.openInfoMessage(nextValue ? 'Fields debug mode on' : 'Fields debug mode off');
  }
}
